import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useDocuments() {
    const api = useApi();
    const state = useAppState();
    function getDocuments(onSuccess = null, refreshCache = false) {
        const config = getApiConfig();
        if (refreshCache) {
            localStorage.removeItem(config.api + (config.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Documents");
        }
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Documents", (result) => {
            state.documents = result.filter((d) => d.processedMeta != null);
            state.documents.forEach((doc) => {
                if (doc.price && doc.price.includes("£")) {
                    doc.price = doc.price.replace("£", "");
                }
                doc.createDateTimeString = new Date(doc.createDateTime).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
            });
            if (onSuccess)
                onSuccess();
        }, true);
    }
    function clearDocuments() {
        const config = getApiConfig();
        localStorage.removeItem(config.api + (config.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/Documents');
    }
    function getDocument(documentId, onSuccess = null, refreshCache = false) {
        const config = getApiConfig();
        if (refreshCache) {
            localStorage.removeItem(config.api + (config.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Documents/" + documentId);
        }
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Documents/" + documentId, (result) => {
            if (onSuccess) {
                console.log(result, 'result');
                result.wellData = JSON.parse(result.processedMeta);
                onSuccess(result);
            }
        }, true);
    }
    function getDocumentsByHubId(hubItemId, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Documents/HubItems/" + hubItemId, (result) => {
            state.documents = result;
            if (onSuccess)
                onSuccess();
        }, true);
    }
    function deleteDocument(documentId, onSuccess = null) {
        getHttpInstance().delete(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Documents/" + documentId)
            .then(() => {
            if (onSuccess)
                onSuccess();
        });
    }
    function updateDocument(document, onSuccess = null) {
        const config = getApiConfig();
        getHttpInstance().put(config.api + "/Customers/00000000-0000-0000-0000-000000000000/Documents/" + document.id, document)
            .then(() => {
            clearDocuments();
            const localCacheUrl = api.cacheUrl("/Customers/00000000-0000-0000-0000-000000000000/Documents/" + document.id);
            localStorage.removeItem(localCacheUrl);
            if (onSuccess)
                onSuccess();
        });
    }
    function getDocumentTypes(onSuccess = null) {
        api.GET("/DocumentTypes", (result) => {
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function getCustomerTags(onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CustomerTags", (result) => {
            state.customerTags = result;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function getTransactionsForCustomerTag(tagId, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CustomerTags/" + tagId + "/Transactions", (result) => {
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function updateTransactionTags(bankAccountId, transactionId, tags, onSuccess = null) {
        const transactionTags = tags.map((t) => t.id ? { "tag": t.tag, "id": t.id } : { "tag": t.tag || t });
        getHttpInstance().put(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/BankAccounts/" + bankAccountId + "/Transactions/" + transactionId + "/CustomerTags", transactionTags)
            .then(() => {
            if (onSuccess)
                onSuccess();
        });
    }
    return {
        getDocuments,
        clearDocuments,
        getDocument,
        getDocumentsByHubId,
        deleteDocument,
        updateDocument,
        getDocumentTypes,
        getCustomerTags,
        getTransactionsForCustomerTag,
        updateTransactionTags,
    };
}
